import { render } from "./HeaderBar.vue?vue&type=template&id=0a074c5f&scoped=true"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=0a074c5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a074c5f"]])

export default __exports__